var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-navbar",
        {
          attrs: { id: "header", type: "light", variant: "light", sticky: "" }
        },
        [
          _c("b-navbar-nav", [
            _c("h4", { staticClass: "mb-0" }, [_vm._v(_vm._s(_vm.title))])
          ]),
          _vm._v(" "),
          _c(
            "b-navbar-nav",
            { staticClass: "ml-auto" },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c("ExportSidebar", {
                        attrs: {
                          "sidebar-id": "sidebar-customers-export",
                          "storage-key": "sidebar_customers_export",
                          columns: _vm.customersExportColumns,
                          "data-to-export": _vm.items,
                          "data-mapper": _vm.mapCustomerForExport,
                          "file-name": "Customers.xlsx",
                          "sheet-name": "Customers",
                          "is-busy": _vm.isBusy,
                          "items-count": _vm.totalRows
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "auto" } },
                    [
                      _c(
                        "b-button",
                        {
                          directives: [
                            {
                              name: "b-toggle",
                              rawName: "v-b-toggle.sidebar-fields",
                              modifiers: { "sidebar-fields": true }
                            }
                          ],
                          staticClass: "mr-2",
                          attrs: {
                            id: "table-settings",
                            size: "sm",
                            variant: "warning"
                          }
                        },
                        [_c("font-awesome-icon", { attrs: { icon: "cog" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-tooltip",
                        {
                          attrs: {
                            target: "table-settings",
                            triggers: "hover",
                            variant: "warning",
                            noninteractive: ""
                          }
                        },
                        [_vm._v("\n            Колонки\n          ")]
                      ),
                      _vm._v(" "),
                      _vm.canEditCustomers()
                        ? _c(
                            "b-button",
                            {
                              attrs: {
                                size: "sm",
                                variant: "success",
                                disabled: _vm.isBusy
                              },
                              on: {
                                click: function($event) {
                                  return _vm.showModal(null, false)
                                }
                              }
                            },
                            [
                              _vm.isBusy
                                ? _c("b-spinner", { attrs: { small: "" } })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("font-awesome-icon", {
                                staticClass: "mr-1",
                                attrs: { icon: "plus" }
                              }),
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t("message.customers.importHand")
                                  ) +
                                  "\n          "
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-navbar",
        { attrs: { variant: "light" } },
        [
          _c(
            "b-navbar-nav",
            [
              _c(
                "filters-drawer",
                {
                  attrs: {
                    query: _vm.filters.query,
                    "is-busy": _vm.isBusy,
                    "filter-tags": _vm.activeFilterTags
                  },
                  on: {
                    "update:query": function($event) {
                      return _vm.$set(_vm.filters, "query", $event)
                    },
                    "remove-tag": _vm.removeFilterTag,
                    submit: _vm.onSearch,
                    clear: _vm.onClearFilters
                  }
                },
                [
                  _c(
                    "b-col",
                    { attrs: { md: "6", cols: "12" } },
                    [
                      _c("label", { staticClass: "small text-muted" }, [
                        _vm._v("Города")
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-form-select",
                        {
                          attrs: { id: "input-town", size: "sm" },
                          model: {
                            value: _vm.filters.town,
                            callback: function($$v) {
                              _vm.$set(_vm.filters, "town", $$v)
                            },
                            expression: "filters.town"
                          }
                        },
                        [
                          _c("option", { domProps: { value: -1 } }, [
                            _vm._v("Все города")
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.towns, function(option) {
                            return _c(
                              "option",
                              { domProps: { value: option.id } },
                              [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(option.name) +
                                    "\n        "
                                )
                              ]
                            )
                          })
                        ],
                        2
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { md: "6", cols: "12" } },
                    [
                      _c("label", { staticClass: "small text-muted" }, [
                        _vm._v("Тип")
                      ]),
                      _vm._v(" "),
                      _c("b-form-select", {
                        attrs: {
                          id: "input-urflag",
                          size: "sm",
                          options: _vm.urflagOptions
                        },
                        model: {
                          value: _vm.filters.urflag,
                          callback: function($$v) {
                            _vm.$set(_vm.filters, "urflag", $$v)
                          },
                          expression: "filters.urflag"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("b-table", {
        ref: "customers",
        staticClass: "mb-0 text-small",
        attrs: {
          id: "customers",
          selectable: "",
          "select-mode": "single",
          selectedVariant: "success",
          striped: "",
          small: "",
          responsive: "",
          "show-empty": "",
          "empty-text": _vm.$t("message.common.emptyTable"),
          busy: _vm.isBusy,
          items: _vm.items,
          fields: _vm.renderedFields,
          "no-provider-filtering": "",
          "no-provider-paging": "",
          "no-provider-sorting": "",
          "sticky-header": "",
          "head-variant": "light"
        },
        on: {
          "update:busy": function($event) {
            _vm.isBusy = $event
          },
          "row-dblclicked": _vm.onRowClicked
        },
        scopedSlots: _vm._u([
          {
            key: "table-busy",
            fn: function() {
              return [
                _c(
                  "div",
                  { staticClass: "text-center text-success my-2" },
                  [
                    _c("b-spinner", { staticClass: "align-middle" }),
                    _vm._v(" "),
                    _c("strong", [_vm._v("Загрузка")])
                  ],
                  1
                )
              ]
            },
            proxy: true
          },
          {
            key: "cell(address)",
            fn: function(row) {
              return [
                row.item.address.length < 50
                  ? _c("div", [_vm._v(_vm._s(row.item.address))])
                  : _c("div", [
                      _vm._v(_vm._s(row.item.address.substring(0, 50) + ".."))
                    ])
              ]
            }
          },
          {
            key: "cell(action)",
            fn: function(row) {
              return [
                _c(
                  "b-dropdown",
                  {
                    attrs: { size: "sm", "no-caret": "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "button-content",
                          fn: function() {
                            return [
                              _c("font-awesome-icon", {
                                attrs: { icon: "ellipsis-v" }
                              })
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      true
                    )
                  },
                  [
                    _vm._v(" "),
                    _c(
                      "b-dropdown-item-button",
                      {
                        attrs: { variant: "success" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.showModal(row.item.id, true)
                          }
                        }
                      },
                      [
                        _c("font-awesome-icon", { attrs: { icon: "eye" } }),
                        _vm._v("\n          Смотреть\n        ")
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.canEditCustomers()
                      ? _c(
                          "b-dropdown-item-button",
                          {
                            attrs: { variant: "primary" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.showModal(row.item.id, false)
                              }
                            }
                          },
                          [
                            _c("font-awesome-icon", {
                              attrs: { icon: "edit" }
                            }),
                            _vm._v("\n          Редактировать\n        ")
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.canEditCustomers()
                      ? _c(
                          "b-dropdown-item-button",
                          {
                            attrs: { variant: "danger" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.onRemove(row)
                              }
                            }
                          },
                          [
                            _c("font-awesome-icon", {
                              attrs: { icon: "trash" }
                            }),
                            _vm._v("\n          Удалить\n        ")
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              ]
            }
          },
          {
            key: "cell(phone)",
            fn: function(row) {
              return [
                _c("a", { attrs: { href: _vm.telUrl(row.item.phone) } }, [
                  _vm._v(_vm._s(_vm.phoneString(row.item.phone)))
                ])
              ]
            }
          },
          {
            key: "cell(urflag)",
            fn: function(row) {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.urFlagString(row.item.urflag)) +
                    "\n    "
                )
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _c("pagination-footer", {
        attrs: { "total-rows": _vm.totalRows, "per-page": _vm.perPage },
        on: {
          "update:perPage": function($event) {
            _vm.perPage = $event
          },
          "update:per-page": function($event) {
            _vm.perPage = $event
          },
          "page-click": _vm.onPagination,
          "per-page-change": _vm.onPerPageChange
        }
      }),
      _vm._v(" "),
      _c("customer", {
        ref: "customer",
        on: { refresh: _vm.getItems, "modal-closed": _vm.onModalClosed }
      }),
      _vm._v(" "),
      _c("dynamic-tables", {
        attrs: {
          "storage-key": "customers_columns",
          "sidebar-fields": "sidebar-fields",
          "fields-model": _vm.fields,
          serviceEndField: _vm.serviceEndField,
          fieldKey: "name"
        },
        on: {
          "update:fieldsModel": function($event) {
            _vm.fields = $event
          },
          "update:fields-model": function($event) {
            _vm.fields = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7bce977b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bce977b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Customers/Customers.vue
// module id = null
// module chunks = 